/**
 * Compute table body viewport height from loaded item count and pagination cap.
 */
export function computeGenericTableViewportHeight(itemCount: number, perPage: number, rowHeightPx: number, maxViewportHeightPx: number, hasMore: boolean): number {
  if (!itemCount) return 0

  if (itemCount >= perPage) {
    return hasMore ? maxViewportHeightPx - 2 : maxViewportHeightPx
  }

  return itemCount * rowHeightPx
}
